import {
  parseEarningDashboardBreakdown,
  parseEarningDashboardSummary,
  parseEarningDashboardTrend,
} from './earningDashboard';

const formatLabel = (value) => {
  const text = (value ?? '').toString().trim();
  return text || '—';
};

export const parseEarningOverview = (data) => {
  const source = data?.result ?? data ?? {};

  const breakdown = parseEarningDashboardBreakdown(source);
  const summary = parseEarningDashboardSummary(source);
  const trend = parseEarningDashboardTrend(source);

  const segments = breakdown.donutSegments.map((seg) => ({
    label: formatLabel(seg.label),
    amount: seg.value,
    percentage: seg.pct != null ? Number(parseFloat(seg.pct).toFixed(1)) : 0,
  }));

  const hasData = segments.length > 0 || summary.hasData || Boolean(trend);
  if (!hasData) return null;

  return { segments, summary, trend };
};
